import { AnimatePresence, motion } from "framer-motion";
import { useMenuState } from "../menu/menu-drawer";

export function MenuDrawerSkeleton(props: { children: React.ReactNode }) {
	const { isDrawerOpen } = useMenuState();

	return (
		<AnimatePresence>
			{isDrawerOpen && (
				<motion.div
					className="fixed inset-0 top-14 landscape:left-14 landscape:top-0 desktop-nav:top-0 desktop-nav:left-10 z-(--illumi-z-index-navbar-container) overflow-y-auto bg-surface-default desktop-nav:hidden"
					initial={{ x: "-100%" }}
					animate={{ x: 0 }}
					exit={{ x: "-100%" }}
					transition={{ duration: 0.1, type: "spring", bounce: 0 }}
				>
					{props.children}
				</motion.div>
			)}
		</AnimatePresence>
	);
}


